module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-beratung-245d846a6c0372ef532882aae6d32da6.svg";